import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-statistics',
  templateUrl: './driver-statistics.component.html',
  styleUrls: ['./driver-statistics.component.css']
})
export class DriverStatisticsComponent implements OnInit {
  incentiveDetails;
  months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  constructor() { }

  ngOnInit() {
  }
  applyIncentive(){}
  openIncentiveModal(){}
}
